module.exports = __webpack_public_path__ + "img/202412250202.7543d434.png";